<template>
  <el-container direction="vertical" id="insureDetails">
    <el-row class="row-bg">
      <!-- 头部 -->
      <el-header>
        <el-col :span="24" style="text-align: center">
          <div>
            <span class="p-title">{{dynamicValidateForm.projectName}}</span>
          </div>
        </el-col>
        <el-col :span="14" :push="5" class="my-step">
          <el-steps :active="1" align-center>
            <el-step title="选择投保方案"></el-step>
            <el-step title="填写投保信息"></el-step>
            <el-step title="在线支付"></el-step>
            <el-step title="完成投保"></el-step>
          </el-steps>
        </el-col>
      </el-header>
    </el-row>
    <el-main>
      <!-- 表单计划 -->
      <el-row>
        <el-col :span="16" :push="4">
          <el-form :model="dynamicValidateForm" ref="dynamicValidateForm" label-width="200px" class="demo-dynamic" style="text-align: left">
            <span v-if="this.$$.isValidObj(dynamicValidateForm.quoteMainNum)">
              <el-card class="box-card">
                <div class="box-card-div-title userInfo"><div class="header">基础信息</div></div>
                <el-form-item :label="baseSpec.name" class="form-item-label" :key="baseSpec.name" v-for="baseSpec in dynamicValidateForm.baseSpecList">
                <el-input class="form-item-input my-input" :disabled="true"
                          :value="baseSpec.specName"></el-input>
                 </el-form-item>
                <el-form-item label="投保单位" class="form-item-label">
                  <el-input class="form-item-input my-input-left " :disabled="true"
                            v-model="dynamicValidateForm.companyName"
                            placeholder="请填写与营业执照上一致的单位名称（必填）"
                  ></el-input>
                </el-form-item>
              </el-card>
              <el-card class="box-card"
                       v-for="(card, index) in dynamicValidateForm.cards"
                       :key="card.key"
              >
                <div class="box-card-div">
                  <span v-if="index === 0" id="planLocation"></span>
                  <div class="box-card-div-title supportPlan"><div class="header">{{'保障计划' + $$.changeNumToHan(index + 1) }}</div></div>
                  <div :id="card.key">
                    <el-form-item
                      class="form-item-label"
                      :label= "$$.isValidObj(dynamicValidateForm.skuSpecList) ? dynamicValidateForm.skuSpecList[2].name : '职业'"
                      :rules="[
                                { required: true, message: '请选择职业', trigger: 'blur' }
                              ]"
                    >
                      <el-select @change="occOneChange(index)" v-model="card.occOneId" placeholder="请选择"
                                 class="form-item-input my-input" :disabled="true">
                        <el-option
                          v-for="item  in dynamicValidateForm.occOneList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                      <el-select @change="occTwoChange(index)" v-model="card.occTwoId" placeholder="请选择"
                                 class="form-item-input my-input" :disabled="true">
                        <el-option
                          v-for="item in card.occTwoList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                      <el-select @change="occThreeChange(index)" v-model="card.occThreeId" placeholder="请选择"
                                 class="form-item-input my-input" :disabled="true">
                        <el-option
                          v-for="item in card.occThreeList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item class="form-item-label"
                                  :label="'职业代码'">
                      <div class="form-item-input" style="min-width: 144px;width: max-content;padding: 0 10px">{{card.realityOccCode}}</div>
                    </el-form-item>
                    <el-form-item class="form-item-label"
                                  :label="'职业类别'">
                      <div class="form-item-input" style="min-width: 144px;width: max-content;padding: 0 10px">{{card.azcnCode}}</div>
                    </el-form-item>
                    <el-form-item
                      class="form-item-label"
                      :label="'人数'"
                      :rules="[
                                { required: true, message: '请输入人数', trigger: 'blur' }
                              ]"
                    >
                      <el-input class="form-item-input my-input" v-model="card.groupSize" @input="groupSizeChange($event)"
                                placeholder="请输入投保人数"></el-input>
                    </el-form-item>

                    <el-form-item  v-for="(action, i) in dynamicValidateForm.actionSpeList" :key=i :label= "action.name" class="form-item-label special"
                                  :rules="[
                            { required: true, message: '请选择' + action.name, trigger: 'blur' }
                          ]"
                    >
                    <el-select v-model="card.skuSpecNameList[action.name]" placeholder="请选择" class="form-item-input my-input"
                               @change="getChangeEvent(index, action.name)" :disabled="true">
                      <el-option
                        v-for="item in card.skuSpecValueList[action.name]"
                        :key="item.id"
                        :label="item.specName"
                        :value="item.specName">
                      </el-option>
                    </el-select>
                </el-form-item>

                  </div>
                </div>
              </el-card>
            </span>
            <span v-else>
              <el-card class="box-card">
              <div class="box-card-div-title userInfo"><div class="header">投保计划</div></div>
              <el-form-item>
                <el-button :class="parseInt($route.query.planId) === plan.id ? 'true' : 'false'" style="width: 200px;min-width: 144px;border: 0px"
                           v-for="plan in dynamicValidateForm.planList" :key="plan.id" @click="planChange(plan.id)"> {{$$.isValidObj(plan.name) ? plan.name : '默认'}}
                </el-button>
              </el-form-item>
            </el-card>
              <el-card class="box-card">
                <div class="box-card-div-title userInfo"><div class="header">基础信息</div></div>
                <el-form-item :label="baseSpec.name" class="form-item-label" :key="baseSpec.name" v-for="baseSpec in dynamicValidateForm.baseSpecList">
                <el-input class="form-item-input my-input" :disabled="true"
                          :value="baseSpec.specName"></el-input>
                 </el-form-item>
                <el-form-item label="投保单位" class="form-item-label">
                  <el-input class="form-item-input my-input-left "
                            v-model="dynamicValidateForm.companyName"
                            placeholder="请填写与营业执照上一致的单位名称（必填）"
                  ></el-input>
                </el-form-item>
              </el-card>
              <el-card class="box-card"
                       v-for="(card, index) in dynamicValidateForm.cards"
                       :key="card.key"
              >
                <div class="box-card-div">
                  <div class="box-card-div-title supportPlan"><div class="header">{{'保障计划' + $$.changeNumToHan(index + 1) }}</div></div>
                  <div :id="card.key">
                    <el-form-item
                      class="form-item-label"
                      :label="'职业类别'"
                      :rules="[
                                { required: true, message: '请选择职业', trigger: 'blur' }
                              ]"
                    >
                      <el-select @change="occOneChange(index)" v-model="card.occOneId" placeholder="请选择"
                                 class="form-item-input my-input">
                        <el-option
                          v-for="item  in dynamicValidateForm.occOneList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                      <el-select @change="occTwoChange(index)" v-model="card.occTwoId" placeholder="请选择"
                                 class="form-item-input my-input">
                        <el-option
                          v-for="item in card.occTwoList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                      <el-select @change="occThreeChange(index)" v-model="card.occThreeId" placeholder="请选择"
                                 class="form-item-input my-input">
                        <el-option
                          v-for="item in card.occThreeList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                      <div class="form-item-input" style="min-width: 144px;width: max-content;padding: 0 10px">职业代码:{{card.realityOccCode}}</div>
                    </el-form-item>
                    <el-form-item
                      class="form-item-label"
                      :label="'人数'"
                      :rules="[
                                { required: true, message: '请输入人数', trigger: 'blur' }
                              ]"
                    >
                      <el-input class="form-item-input my-input" v-model="card.groupSize" @input="groupSizeChange($event)"
                                placeholder="请输入投保人数"></el-input>
                    </el-form-item>
                    <el-form-item  v-for="(action, i) in dynamicValidateForm.actionSpeList" :key=i :label= "action.name" class="form-item-label special"
                                  :rules="[
                            { required: true, message: '请选择' + action.name, trigger: 'blur' }
                          ]"
                    >
                    <el-select v-model="card.skuSpecNameList[action.name]" placeholder="请选择" class="form-item-input my-input"
                               @change="getChangeEvent(index, action.name)">
                      <el-option
                        v-for="item in card.skuSpecValueList[action.name]"
                        :key="item.id"
                        :label="item.specName"
                        :value="item.specName">
                      </el-option>
                    </el-select>
                </el-form-item>
                  </div>
                </div>
              </el-card>
            </span>
            <el-card class="box-card">
              <div class="box-card-div-title userInfo"><div class="header">投保信息</div></div>
              <el-form-item label="起保日期" class="form-item-label">
                <div class="block">
                  <el-date-picker
                    v-model="beInsuredEffectiveDate"
                    value-format="yyyy-MM-dd"
                    type="date"
                    format="yyyy 年 MM 月 dd 日"
                    align="center"
                    placeholder="请选择"
                    class="my-el-date-picker"
                    :picker-options="pickerOptions"
                  >
                  </el-date-picker>
                </div>
              </el-form-item>
              <el-form-item label="投保人所在区域" class="form-item-label">
                <el-select @change="provinceChange" v-model="provinceId" placeholder="请选择"
                           class="form-item-input my-input">
                  <el-option
                    v-for="item in chinaArea"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
                <el-select @change="cityChange" v-model="cityId" placeholder="请选择"
                           class="form-item-input my-input">
                  <el-option
                    v-for="item in cityList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
                <el-select @change="areaChange" v-model="areaId" placeholder="请选择"
                           class="form-item-input my-input">
                  <el-option
                    v-for="item in areaList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="投保人详细地址" class="form-item-label">
                <el-input class="form-item-input my-input-left "
                          v-model="specificAddress"
                          placeholder="请填写营业执照上的注册详细地址"
                ></el-input>
              </el-form-item>
              <el-form-item label="证件类型" class="form-item-label">
                <el-select v-model="idType" placeholder="请选择"
                           class="form-item-input my-input" style="width: 200px">
                  <el-option label="社会统一信用代码" :value=6></el-option>
                  <el-option label="组织机构代码证" :value=11></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="证件号码" class="form-item-label">
                <el-input class="form-item-input my-input-left "
                          v-model="socialCreditCode"
                          placeholder="请填写投保单位证件号码"
                          maxlength="18"
                ></el-input>
              </el-form-item>
              <el-form-item label="联系人姓名" class="form-item-label">
                <el-input class="form-item-input my-input-left "
                          v-model="legalPerson"
                          placeholder="联系人姓名必须真实填写"
                ></el-input>
              </el-form-item>
              <el-form-item label="联系人手机号" class="form-item-label">
                <el-input class="form-item-input my-input-left "
                          v-model="mobile"
                          maxlength="11"
                          onkeyup="value=value.replace(/[^\d]/g,'')"
                          placeholder="联系人手机号码必须真实填写"
                ></el-input>
              </el-form-item>
              <el-form-item label="联系人地址" class="form-item-label">
                <el-input class="form-item-input my-input-left "
                          v-model="address"
                          placeholder="此地址供保险公司邮寄发票时使用"
                ></el-input>
              </el-form-item>
              <el-form-item label="联系人邮箱" class="form-item-label">
                <el-input class="form-item-input my-input-left "
                          v-model="workEmail"
                          placeholder="此邮箱为电子发票、电子保单发送邮箱"
                ></el-input>
              </el-form-item>
            </el-card>
            <el-card class="box-card underwriterDetailed">
              <div class="box-card-div-title" style="width: 145px"><div class="header" id="beInsureLocation" >被保险人清单</div></div>
              <el-form-item label="人员说明" class="form-item-label">
                <div>
                    <span v-for="(item,index) in dynamicValidateForm.cards">
                      <span class="header-span">{{'保障计划' + $$.changeNumToHan(index + 1) }}：{{item.occOneName}}-{{item.occTwoName}}-{{item.occThreeName}}，{{item.azcnCode}}类职业，职业代码：{{item.realityOccCode}}，人数：{{item.groupSize}}</span><br>
                    </span>
                </div>
              </el-form-item>
              <el-form-item label="批量导入" class="form-item-label">
                <el-button class="header-row-col-button-success"><a id="a" style="display: inline"
                          @click="$$.download('https://pic.xiaobaibao.com/system/reportTemp/2021/6/76aa6dc8c4b8416e91672900827c5118.xls','被保险人清单模板')"
                >下载模板</a></el-button>
                <el-upload style="display: inline-block"
                           action="#"
                           :before-upload="uploadFileExcel"
                           :show-file-list="false"
                >
                  <el-button class="header-row-col-button-failure">上传被保险人清单</el-button>
                </el-upload>
                <el-button class="header-row-col-button-failure" @click="deleteBeInsureTableDataBatch">批量删除被保险人</el-button>
              </el-form-item>
              <el-form-item label="单个新增" class="form-item-label">
                <el-button class="header-row-col-button-failure" @click="addDialogVisible = true">新增</el-button>
              </el-form-item>
              <el-dialog
                title="新增被保险人员"
                :visible.sync="addDialogVisible"
                width="424px"
                center>
                <el-form-item label="姓名" class="form-item-label-add">
                  <el-input class="form-item-input-add my-input-add" style="width: 264px"
                            v-model="addBeInsureData.addBeInsureName"
                            placeholder="请输入被保险人员姓名"
                  ></el-input>
                </el-form-item>
                <el-form-item label="证件类型" class="form-item-label-add">
                  <el-select v-model="addBeInsureData.addBeInsureIdType" placeholder="请选择"
                             class="form-item-input-add my-input-add" style="width: 264px">
                    <el-option label="身份证" :value=1></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="证件号码" class="form-item-label-add">
                  <el-input class="form-item-input-add my-input-add" style="width: 264px"
                            v-model="addBeInsureData.addBeInsureIdCard"
                            placeholder="请输入被保险人证件号码"
                            @change="addBeInsureIdCardChange"
                  ></el-input>
                </el-form-item>
                <el-form-item label="性别" class="form-item-label-add">
                  <el-select v-model="addBeInsureData.addBeSex" placeholder="请选择"
                             class="form-item-input-add my-input-add" style="width: 264px">
                    <el-option label="男性" value="M"></el-option>
                    <el-option label="女性" value="F"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="出生日期" class="form-item-label-add">
                  <div class="block">
                    <el-date-picker
                      v-model="addBeInsureData.addBeBirthday"
                      type="date"
                      align="center"
                      placeholder="请选择"
                      value-format="yyyy-MM-dd"
                      class="my-el-date-picker-add">
                    </el-date-picker>
                  </div>
                </el-form-item>
                <el-form-item label="保障计划" class="form-item-label-add">
                  <el-select v-model="addBeInsureData.bePlan" placeholder="请选择"
                             class="form-item-input-add my-input-add" style="width: 264px" @change="bePlanChange">
                    <el-option
                      v-for="(item,index) in  dynamicValidateForm.cards"
                      :key="index+1"
                      :label="'保障计划' + $$.changeNumToHan(index + 1)"
                      :value="index+1">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="职业代码" class="form-item-label-add">
                  <!--<el-select v-model="addBeInsureData.addRealityOccCode" placeholder="请选择"
                             class="form-item-input-add my-input-add" style="width: 264px" :disabled="true">
                    <el-option
                      v-for="item in  dynamicValidateForm.cards"
                      :key="item.realityOccCode"
                      :label="item.occThreeName"
                      :value="item.realityOccCode">
                    </el-option>
                  </el-select>-->
                  <div class="form-item-input-add my-input-add" style="width: 264px;text-align: center;padding: 0 30px 0 10px;">{{addBeInsureData.addRealityOccCode}}</div>
                </el-form-item>
                <div class="dialog-footer">
                  <el-button class="header-row-col-button-failure-add" @click="cancelAddDialogVisible">取 消</el-button>
                  <el-button type="primary" class="header-row-col-button-success-add" @click="submitAddDialogVisible">确 定</el-button>
                </div>
              </el-dialog>
              <el-form-item label="人员清单" class="form-item-label">
                <el-table
                  :data="beInsureTableData"
                  v-loading="loading"
                  border
                  max-height="500"
                  @selection-change="handleSelectionChange"
                  class="my-el-table" style="margin-left: 0;">
                  <el-table-column
                    type="selection"
                    width="55">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="index"
                    type="index"
                    label="序号"
                    width="50">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="beInsureName"
                    label="姓名">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="beInsureIdType"
                    label="证件类型"
                    width="80">
                    <template slot-scope="scope">
                      <div v-if="scope.row.beInsureIdType === 1">身份证</div>
                      <!--<div v-if="scope.row.beInsureIdType === 3">中国护照</div>
                      <div v-if="scope.row.beInsureIdType === 5">港澳台通行证</div>-->
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="beInsureIdCard"
                    label="证件号码"
                    width="182">
                    <template slot-scope="scope">
                      <div style="text-align: center">
                        <p style="margin-top:0;margin-bottom:0">{{scope.row.beInsureIdCard}}</p>
                        <p v-if="scope.row.idCardErrorMsg !== ''" style="margin-top:0;margin-bottom:0;color: #FF7052">
                          {{scope.row.idCardErrorMsg}}</p>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="beSex"
                    label="性别"
                    width="55">
                    <template slot-scope="scope">
                      <div v-if="scope.row.beSex === 'M'">男性</div>
                      <div v-if="scope.row.beSex === 'F'">女性</div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="beBirthday"
                    label="出生日期"
                    value-format="yyyy-MM-dd"
                    width="101">
                    <template slot-scope="scope">
                      <div style="text-align: center">
                        <p style="margin-top:0;margin-bottom:0">{{scope.row.beBirthday}}</p>
                        <p v-if="scope.row.ageErrorMsg !== ''" style="margin-top:0;margin-bottom:0;color: #FF7052">
                          {{scope.row.ageErrorMsg}}</p>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="bePlan"
                    label="保障计划"
                    width="90">
                    <template slot-scope="scope">
                      <div style="text-align: center">
                        <p style="margin-top:0;margin-bottom:0">{{scope.row.bePlan}}</p>
                        <p v-if="scope.row.planErrorMsg !== ''" style="margin-top:0;margin-bottom:0;color: #FF7052">
                          {{scope.row.planErrorMsg}}</p>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="realityOccCode"
                    label="职业代码"
                    width="102">
                    <template slot-scope="scope">
                      <div style="text-align: center">
                        <p style="margin-top:0;margin-bottom:0">{{scope.row.realityOccCode}}</p>
                        <p v-if="scope.row.codeErrorMsg !== ''" style="margin-top:0;margin-bottom:0;color: #FF7052">
                          {{scope.row.codeErrorMsg}}</p>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    width="55">
                    <template slot-scope="scope">
                      <el-link type="warning"
                               @click.native.prevent="deleteBeInsureTableData(scope.$index, beInsureTableData)">删除
                      </el-link>
                    </template>
                  </el-table-column>
                </el-table>
              </el-form-item>
            </el-card>
            <el-card class="box-card">
              <div class="box-card-div-title userInfo"><div class="header">发票信息</div></div>
              <el-form-item label="是否需要" class="form-item-label-big">
                <el-radio-group v-model="needInvoices">
                  <el-radio-button class="my-button" :label="true">需要</el-radio-button>
                  <el-radio-button class="my-button" :label="false">不需要</el-radio-button>
                </el-radio-group>
              </el-form-item>
              <span v-if="needInvoices">
                  <el-form-item label="发票类型" class="form-item-label-big">
                  <div>
                    <el-radio-group v-model="receiptType">
                      <el-radio-button class="my-button" :label="2">普通发票(电子发票)</el-radio-button>
                      <el-radio-button class="my-button" :label="1">增值税专用发票（纸质发票）</el-radio-button>
                    </el-radio-group>
                  </div>
                  </el-form-item>
                  <span v-if="receiptType === 2">
                    <el-form-item label="发票内容" class="form-item-label-big"></el-form-item>
                    <el-form-item label="发票抬头" class="form-item-label">
                      <el-input :disabled="true" class="form-item-input my-input-left "
                                v-model="dynamicValidateForm.companyName"
                                placeholder="请输入发票抬头"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="纳税人识别号" class="form-item-label">
                      <el-input v-if="idType === 6" class="form-item-input my-input-left "
                                v-model="socialCreditCode" :disabled="true"
                                placeholder="请输入纳税人识别号"
                      ></el-input>
                      <el-input v-else class="form-item-input my-input-left "
                                v-model="orderMailInvoiceInfo.tIN"
                                placeholder="请输入纳税人识别号"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="收件人信息" class="form-item-label-big"></el-form-item>
                    <el-form-item label="收件人姓名" class="form-item-label">
                      <el-input class="form-item-input my-input-left "
                                v-model="orderMailInvoiceInfo.rName"
                                placeholder="请输入收件人姓名"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="收件人手机号" class="form-item-label">
                      <el-input class="form-item-input my-input-left "
                                v-model="orderMailInvoiceInfo.rPhone"
                                placeholder="请输入收件人手机号码"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="收件人邮箱" class="form-item-label">
                      <el-input class="form-item-input my-input-left "
                                v-model="orderMailInvoiceInfo.rMail"
                                placeholder="请输入收件人邮箱"
                      ></el-input>
                    </el-form-item>
                  </span>
                  <span v-else-if="receiptType === 1">
                  <el-form-item label="发票内容" class="form-item-label-big"></el-form-item>
                    <el-form-item label="发票抬头" class="form-item-label">
                      <el-input :disabled="true" class="form-item-input my-input-left "
                                v-model="dynamicValidateForm.companyName"
                                placeholder="请输入发票抬头"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="纳税人识别号" class="form-item-label">
                      <el-input v-if="idType === 6" class="form-item-input my-input-left "
                                v-model="socialCreditCode" :disabled="true"
                                placeholder="请输入纳税人识别号"
                      ></el-input>
                      <el-input v-else class="form-item-input my-input-left "
                                v-model="orderMailInvoiceInfo.tIN"
                                placeholder="请输入纳税人识别号"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="税务登记地址" class="form-item-label">
                      <el-input class="form-item-input my-input-left "
                                v-model="orderMailInvoiceInfo.tRA"
                                placeholder="请输入税务登记地址"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="税务登记电话" class="form-item-label">
                      <el-input class="form-item-input my-input-left "
                                v-model="orderMailInvoiceInfo.tRT"
                                placeholder="请输入税务登记电话"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="开户银行" class="form-item-label">
                      <el-select v-model="orderMailInvoiceInfo.openBank" placeholder="请选择开户银行" class="form-item-input my-input-left" style="width: 200px">
                        <el-option
                          v-for="item in bankTypeList"
                          :key="item.label"
                          :label="item.label"
                          :value="item.label">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="银行账户" class="form-item-label">
                      <el-input class="form-item-input my-input-left "
                                v-model="orderMailInvoiceInfo.bankNum"
                                placeholder="银行账户"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="收件人信息" class="form-item-label-big"></el-form-item>
                    <el-form-item label="收件人姓名" class="form-item-label">
                      <el-input class="form-item-input my-input-left "
                                v-model="orderMailInvoiceInfo.rName"
                                placeholder="请输入收件人姓名"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="收件人手机号" class="form-item-label">
                      <el-input class="form-item-input my-input-left "
                                v-model="orderMailInvoiceInfo.rPhone"
                                placeholder="请输入收件人手机号码"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="收件人地址" class="form-item-label">
                    <el-select @change="rProvinceChange" v-model="orderMailInvoiceInfo.rProvinceId" placeholder="请选择"
                               class="form-item-input my-input">
                      <el-option
                        v-for="item in chinaArea"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                    <el-select @change="rCityChange" v-model="orderMailInvoiceInfo.rCityId" placeholder="请选择"
                               class="form-item-input my-input">
                      <el-option
                        v-for="item in orderMailInvoiceInfo.rCityList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                    <el-select v-model="orderMailInvoiceInfo.rAreaId" placeholder="请选择"
                               class="form-item-input my-input">
                      <el-option
                        v-for="item in orderMailInvoiceInfo.rAreaList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                    </el-form-item>
                    <el-form-item label="具体地址" class="form-item-label">
                      <el-input class="form-item-input my-input-left " style="width: 640px;"
                                v-model="orderMailInvoiceInfo.rAddress"
                                placeholder="请输入具体地址"
                      ></el-input>
                    </el-form-item>
                </span>
                </span>
            </el-card>
            <el-card class="box-card">
              <div class="box-card-div-title supportPlan"><div class="header">受益人信息</div></div>
              <el-form-item label="受益人" class="form-item-label">
                <el-input class="form-item-input my-input" :disabled="true" value="法定受益人"></el-input>
              </el-form-item>
            </el-card>
            <el-dialog
              title="温馨提示"
              :visible.sync="beInsureErrorMsgDialogVisible"
              width="424px"
              center>
              <div v-for="(o, i) in beInsureErrorMsg" :key="o" class="item" style="padding: 10px 0 20px">
                <div>{{i + 1}}、{{ o }}</div>
              </div>
              <div class="space-around">
                <el-button v-if="$$.isValidObj(dynamicValidateForm.quoteMainId)" @click="planLocation" class="header-button-order-add">修改投保计划人数</el-button>
                <el-button @click="beInsureLocation" class="header-button-order-add">修改被保险人清单</el-button>
              </div>
            </el-dialog>
            <template>
              <div style="word-break : break-all;display: inline-flex">
                <!-- `checked` 为 true 或 false -->
                <el-checkbox v-model="checked" @change="checkboxChange" style="padding-right: 3px"></el-checkbox>
                <span class="el-checkbox-span-a" style="color: #666">
                本人已阅读并知悉同意
                <a class="special" style="color: #ff7052;display: contents" target="_blank" href="https://pic.xiaobaibao.com/clause/2021/10/22469315218c427db5651c257da6970b.pdf">《服务协议》、</a>
                <a class="special" style="color: #ff7052;display: contents" target="_blank" href="https://pic.xiaobaibao.com/clause/2021/10/e18184f2896e4f1883b892726e445f47.pdf">《客户告知书》、</a>
                <a class="special" style="color: #ff7052;display: contents" target="_blank" href="https://pic.xiaobaibao.com/clause/2021/10/5027df20e25248c6bcffc4172c3a27b3.pdf">《企业险授权委托书》、</a>
                <el-dropdown>
                  <a class="special" style="color: #ff7052">
                    《保险条款》、
                  </a>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="i in InsuranceClauseTypeZero" v-bind:key="i.id">
                      <a class="special" target="_blank" :href="i.tikuanUrl">{{i.tikuanName.replace('.pdf','')}}</a>
                    </el-dropdown-item>
                  </el-dropdown-menu>
              </el-dropdown>
                  <a class="special" v-for="(i,index) in InsuranceClauseTypeOne" target="_blank" :href="i.tikuanUrl" style="color: #ff7052;display: contents">《{{i.tikuanName.replace('.pdf','')}}》<span v-if="index+1 !== InsuranceClauseTypeOne.length">、</span></a>
              </span>
              </div>
            </template>
            <div class="submitOrder">
              <el-button @click="submitOrder" class="header-button-order-add">提交订单</el-button>
            </div>
          </el-form>
        </el-col>
      </el-row>
      <el-dialog
        :title="pdfTitle"
        :visible.sync="pdfVisible"
        :show-close="false"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        center
      >
          <div style="height: 800px;">
            <el-scrollbar style="height:100%" ref="pdfScrollbar">
              <pdf
                v-for="i in numPages"
                :key="i"
                :page="i"
                :src="src"
                @num-pages="pageCount=$event"
              >
              </pdf>
            </el-scrollbar>
          </div>
        <span slot="footer" class="dialog-footer">
          <el-button v-if="pdfNum !== InsuranceClauseTypeZero.length - 1" type="danger" @click="pdfCheck" :disabled="pdfButtonClick">{{pdfButtonContent}}</el-button>
          <el-button v-else type="danger" @click="pdfVisible = false" :disabled="pdfButtonClick">{{pdfButtonContent}}</el-button>
          <span style="display: block;padding-top: 20px; color: red">《服务协议》、《客户告知书》、《企业险授权书》、《保险条款》、《免责条款》请点击投保页面下方阅读</span>
        </span>
      </el-dialog>
    </el-main>
  </el-container>
</template>

<script type="text/javascript">

  import pdf from 'vue-pdf'

  export default {
    name: "insureDetails",
    components: {pdf},
    data() {
      return {
        dynamicValidateForm: {
          cards: [{
            groupSize: '',
            occId: '',
            realityOccCode: '',
            //-- 职业参数
            occOneId: '',
            occTwoList: [],
            occTwoId: '',
            occThreeList: [],
            occThreeId: '',
            occOneName: '',
            occTwoName: '',
            occThreeName: '',
            //职业id
            occupationId: 0,
            //职业类别
            azcnCode: '',
            //取值获取规格值下拉选项
            pid: 0,
            topLevelId: 0,
            skuInfo: {},
            skuSpecValueList: {},
            skuSpecNameList: {}
          }],
          companyName: '',
          occOneList: [],
          projectName: '',
          //-- sku参数
          skuList: [],
          skuSpecList: [],
          skuRelationAddList: [],
          occupationList: [],
          baseSpecList: [],
          actionSpeList: [],
          skuBaseTitle: "",
          planList: []
        },
        orderMailInvoiceInfo: {
          tIN: '',            // 纳税人识别号
          rName: '',          // 收件人姓名
          rPhone: '',         // 收件人手机号
          rMail: '',          // 收件人邮箱
          tRA: '',            // 税务登记地址
          tRT: '',            // 税务登记电话
          openBank: '',       // 开户银行
          bankNum: '',        // 银行账户
          rCityId: '',        // 	城市ID
          rProvinceId: '',    // 	省份ID
          rAreaId: '',        // 	地区ID
          rAddress: '',       // 收件人具体地址
          rCityList: [],
          rAreaList: []
        },
        addBeInsureData: {
          addBeInsureName: '',     // 被保人姓名
          addRealityOccCode: '',  // 被保人职业代码
          addBeBirthday: '',     // 被保人出生日期
          addBeSex: '',          // 被保人性别
          addBeInsureIdCard: '',  // 被保人证件号
          addBeInsureIdType: '', // 被保人证件类型
          bePlan: '' // 被保人对应计划
        },
        // -- 被保人列表
        beInsureErrorMsg : [], // 错误信息
        beInsureSelection: [], // 被保人选中数据
        loading: false,
        beInsureTableData: [],
        cityId: '', // 	城市ID
        provinceId: '', // 	省份ID
        areaId: '', // 	地区ID
        cityName: '', // 	城市名称
        provinceName: '', // 	省份名称
        areaName: '', // 地区名称
        socialCreditCode: '', // 证件号码
        address: '', // 联系人具体地址
        specificAddress: '', // 公司具体地址
        mobile: '',// 联系人手机号
        legalPerson: '', // 联系人
        workEmail: '', // 联系人邮箱
        cityList: [],
        areaList: [],
        beInsuredEffectiveDate: '',// 起保日期
        needInvoices: false,
        receiptType: 2,
        chinaArea: this.chinaLifeAccidentDistrict.chinaAreaList(),
        idType: '',
        addDialogVisible: false, // 添加被保人按钮弹出框
        beInsureErrorMsgDialogVisible: false, // 添加被保人按钮弹出框
        requestToken: '',
        submitOrderData: {},
        bankTypeList: [],        // 开户银行类型列表
        addToDay: 0,
        pickerOptions: {
          disabledDate: this.disabledDate
        },
        ageMin : 0,
        ageMax : 0,
        // -- pdf
        numPages:0,
        pageCount:0,
        pdfTime: 2,
        pdfNum : 0,
        pdfButtonClick: true,
        pdfButtonContent: '我 已 阅 读',
        pdfVisible:false,// pdf弹出框
        pdfTitle:'',
        src: '', // pdf文件地址
        checked: false,
        InsuranceClauseTypeZero : [],
        InsuranceClauseTypeOne : [],
        productId: "",
        planId: ""
      };
    },
    methods: {
      //-- 点击计划时
      planChange(id){
        if( this.dynamicValidateForm.planId === id ){
          return
        }
        this.$route.query.planId = id;
        this.dynamicValidateForm.planId = id;
        this.dynamicValidateForm.cards.forEach(item => {
          item.groupSize = '';
          item.occId = '';
          item.realityOccCode = '';
          //-- 职业参数
          item.occOneId = '';
          item.occTwoList = [];
          item.occTwoId = '';
          item.occThreeList = [];
          item.occThreeId = '';
          item.occOneName = '';
          item.occTwoName = '';
          item.occThreeName = '';
          //职业id
          item.occupationId = 0;
          //职业类别
          item.azcnCode = '';
          //取值获取规格值下拉选项
          item.pid = 0;
          item.topLevelId = 0;
          item.skuInfo = {};
          item.skuSpecValueList = {};
          item.skuSpecNameList = {};
        });
        this.getSkuInfo();
      },
      loadPdfHandler () {
        //src为你服务器上存放pdf的路径
        this.src = pdf.createLoadingTask(this.src);
        this.src.promise.then(pdf => {
          this.numPages = pdf.numPages;
        });
      },
      pdfButtonLoad(){
        this.pdfButtonClick = true;
        let clock = window.setInterval(() => {
          this.pdfTime--;
          if (this.pdfTime < 0) {
            window.clearInterval(clock);
            this.pdfButtonClick = false;
            this.pdfTime = 2;
          }
        },1000);
      },
      pdfCheck(){
        this.$refs.pdfScrollbar.wrap.scrollTop = 0;
        this.pdfNum++;
        if(!this.$$.isEmptyObject(this.InsuranceClauseTypeOne)){
          this.InsuranceClauseTypeOne.forEach((item,index) => {
            if(index === this.pdfNum){
              this.pdfButtonLoad();
              this.src = item.tikuanUrl;
              this.pdfTitle = item.tikuanName.replace('.pdf','');
              this.loadPdfHandler();
            }
          })
        }
      },
      checkboxChange(val){
        if(val === true){
          if(!this.$$.isEmptyObject(this.InsuranceClauseTypeOne)){
            this.pdfButtonLoad();
            this.src = this.InsuranceClauseTypeOne[0].tikuanUrl;
            this.pdfTitle = this.InsuranceClauseTypeOne[0].tikuanName.replace('.pdf','');
            this.loadPdfHandler();
            this.pdfNum = 0;
            this.pdfVisible = true;
          }
        }
      },
      getInsuranceClause(){
        this.axios.post('/management/mobileInsuranceClause/getInsuranceClause?productId='+this.$route.query.productId+'&clauseType=1', {}).then((response) => {
          if(response.data.success){
            this.InsuranceClauseTypeOne = response.data.datas;
          }
        });
        this.axios.post('/management/mobileInsuranceClause/getInsuranceClause?productId='+this.$route.query.productId, {}).then((response) => {
          if(response.data.success){
            this.InsuranceClauseTypeZero = response.data.datas;
          }
        });
      },
      disabledDate(time) {
        let _now = Date.now(),
          day = this.addToDay * 24 * 60 * 60 * 1000,
          days = _now + day;
        return time.getTime() < days;
        //大于当前的禁止，小于7天前的禁止
      },
      takeInPlan(item) {
        !document.getElementById(item.key).hasAttribute("hidden") ?
          document.getElementById(item.key).setAttribute("hidden", "hidden") :
          document.getElementById(item.key).removeAttribute("hidden");
      },
      removeDomain(item) {
        const index = this.dynamicValidateForm.cards.indexOf(item);
        if (index !== -1) {
          this.dynamicValidateForm.cards.splice(index, 1)
        }
      },
      addDomain() {
        this.dynamicValidateForm.cards.push({
          value: '',
          key: Date.now()
        });
      },
      bePlanChange() {
        this.dynamicValidateForm.cards.forEach((item, index) => {
          index + 1 === this.addBeInsureData.bePlan ? this.addBeInsureData.addRealityOccCode = item.realityOccCode : '';
        });
      },
      //-- 当选择第一个职业
      occOneChange(index) {
        this.$forceUpdate();
        this.dynamicValidateForm.occOneList.forEach(item => {
          item.id === this.dynamicValidateForm.cards[index].occOneId ? this.dynamicValidateForm.cards[index].occTwoList = item.children : [];
          item.id === this.dynamicValidateForm.cards[index].occOneId ? this.dynamicValidateForm.cards[index].occOneName = item.name : '';
        });
        this.dynamicValidateForm.cards[index].skuInfo = {};
        this.dynamicValidateForm.cards[index].occTwoId = '';
        this.dynamicValidateForm.cards[index].occThreeId = '';
        this.dynamicValidateForm.cards[index].occThreeList = [];
        this.dynamicValidateForm.cards[index].realityOccCode = '';
        this.dynamicValidateForm.cards[index].azcnCode = '';
        this.dynamicValidateForm.cards[index].occThreeName = '';
        this.dynamicValidateForm.cards[index].occId = '';
      },
      //-- 当选择第二个职业
      occTwoChange(index) {
        this.$forceUpdate();
        this.dynamicValidateForm.cards[index].occTwoList.forEach(item => {
          item.id === this.dynamicValidateForm.cards[index].occTwoId ? this.dynamicValidateForm.cards[index].occThreeList = item.children : [];
          item.id === this.dynamicValidateForm.cards[index].occTwoId ? this.dynamicValidateForm.cards[index].occTwoName = item.name : '';
        });
        this.dynamicValidateForm.cards[index].skuInfo = {};
        this.dynamicValidateForm.cards[index].occThreeId = '';
        this.dynamicValidateForm.cards[index].realityOccCode = '';
        this.dynamicValidateForm.cards[index].azcnCode = '';
        this.dynamicValidateForm.cards[index].occThreeName = '';
        this.dynamicValidateForm.cards[index].occId = '';
      },
      //-- 当选择第三个职业
      occThreeChange(index) {
        this.$forceUpdate();
        this.dynamicValidateForm.cards[index].occupationId = 0;
        this.dynamicValidateForm.cards[index].occThreeList.forEach(item => {
          item.id === this.dynamicValidateForm.cards[index].occThreeId ? this.dynamicValidateForm.cards[index].occId = item.id : '';
          item.id === this.dynamicValidateForm.cards[index].occThreeId ? this.dynamicValidateForm.cards[index].azcnCode = item.azcnCode : '';
          item.id === this.dynamicValidateForm.cards[index].occThreeId ? this.dynamicValidateForm.cards[index].occThreeName = item.name : '';
          item.id === this.dynamicValidateForm.cards[index].occThreeId ? this.dynamicValidateForm.cards[index].realityOccCode = item.realityOccCode : '';
        });
        this.dynamicValidateForm.occupationList.forEach(item => {
          if (this.dynamicValidateForm.cards[index].occupationId == 0) this.dynamicValidateForm.cards[index].occupationId = item.specValue == this.dynamicValidateForm.cards[index].azcnCode ? item.id : 0;
        });
        this.dynamicValidateForm.cards[index].skuInfo = {};
        this.dynamicValidateForm.skuRelationAddList.forEach(item => {
          if (item.id == this.dynamicValidateForm.cards[index].occupationId) {
            this.dynamicValidateForm.cards[index].pid = item.id;
            this.dynamicValidateForm.cards[index].topLevelId = item.pid;
            return;
          }
        });

        this.dynamicValidateForm.cards[index].skuSpecNameList = {};
        this.dynamicValidateForm.cards[index].skuSpecValueList = {};
        this.dynamicValidateForm.actionSpeList.forEach(item => {
          this.dynamicValidateForm.cards[index].skuSpecNameList[item.name] = "";
          this.dynamicValidateForm.cards[index].skuSpecValueList[item.name] = "";
        });
        let list = [];
        this.dynamicValidateForm.cards[index].skuSpecValueList = {};
        this.dynamicValidateForm.cards[index].skuSpecNameList = {};
        this.dynamicValidateForm.skuRelationAddList.forEach(item => {
          if (item.pid == this.dynamicValidateForm.cards[index].pid && item.topLevelId == this.dynamicValidateForm.cards[index].topLevelId) {
            let json = {};
            json['id'] = item.id;
            json['specName'] = item.name;
            json['topLevelId'] = item.pid;
            list.push(json);
            return;
          }
        });
        this.dynamicValidateForm.cards[index].skuSpecValueList[this.dynamicValidateForm.actionSpeList[0].name] = list;

      },
      getChangeEvent(i, name){
        this.$forceUpdate();

        let num = 0;

        for (let skuSpecValueListKey in this.dynamicValidateForm.cards[i].skuSpecValueList) {
          if ( skuSpecValueListKey !== name ){
            num++;
          }else {
            this.dynamicValidateForm.cards[i].skuSpecValueList[name].forEach(item => {
              if( item.specName ===  this.dynamicValidateForm.cards[i].skuSpecNameList[name]) {
                this.dynamicValidateForm.cards[i].pid = item.id;
                this.dynamicValidateForm.cards[i].topLevelId = item.topLevelId;
              }
            });
            break;
          }
        }

        for (let j = num+1; j < this.dynamicValidateForm.actionSpeList.length; j++) {
          this.dynamicValidateForm.cards[i].skuSpecNameList[this.dynamicValidateForm.actionSpeList[j].name] = "";
          this.dynamicValidateForm.cards[i].skuSpecValueList[this.dynamicValidateForm.actionSpeList[j].name] = "";
        }

        let list = [];
        let dataTitle = this.dynamicValidateForm.skuBaseTitle + this.dynamicValidateForm.cards[i].azcnCode + '类-';
        for (let skuSpecNameListKey in this.dynamicValidateForm.cards[i].skuSpecNameList) {
          if( this.$$.isValidObj(this.dynamicValidateForm.cards[i].skuSpecNameList[skuSpecNameListKey]) )
            dataTitle += this.dynamicValidateForm.cards[i].skuSpecNameList[skuSpecNameListKey] + "-";
        }

        dataTitle = dataTitle.substring(0, dataTitle.length-1);

        this.dynamicValidateForm.skuRelationAddList.forEach(item => {
          if (item.pid == this.dynamicValidateForm.cards[i].pid && item.topLevelId == this.dynamicValidateForm.cards[i].topLevelId && item.remarks.indexOf(dataTitle) != -1) {
            let json = {};
            json['id'] = item.id;
            json['specName'] = item.name;
            json['topLevelId'] = item.pid;
            list.push(json);
            return;
          }
        });

        if( this.dynamicValidateForm.actionSpeList.length !== num+1 ) this.dynamicValidateForm.cards[i].skuSpecValueList[this.dynamicValidateForm.actionSpeList[num+1].name] = list;

        if( this.dynamicValidateForm.actionSpeList.length === num+1 ) {
          let params = {};
          let skuSpec = [];
          skuSpec.push(dataTitle);
          params.insuranceInfoId = this.dynamicValidateForm.productId;
          params.planId = this.dynamicValidateForm.planId;
          params.skuSpec = skuSpec;
          this.axios.post('/management/mobileInsuranceInfo/getskuSpecRateInfo', this.qs.stringify(params,{indices: false})).then((response) => {
            let data = response.data;
            if( data.success ){
              this.dynamicValidateForm.cards[i].skuInfo = data.data[0];
            }
          });
        }
      },
      //-- 获取开户银行类型列表
      bankTypeLists() {
        this.axios.post('/member/banktype/getBankTypeList', {}).then((response) => {
          let {success, datas, msg} = response.data;
          if (success) {
            let list = [];
            for (let i in datas){
              list.push({
                "label": datas[i].fullName,
              });
            }
            this.bankTypeList = list;
          }else{
            this.$message.info(msg);
          }
        });
      },
      getSkuInfo() {
        let loadingInstance = this.Loading.service({fullscreen: true});
        this.axios.post('/management/mobileInsuranceInfo/getInsuranceSkuDetail?insuranceInfoId=' + this.$route.query.productId + '&planId=' + this.$route.query.planId, {}).then((response) => {
          let data = response.data;
          if (data.success) {
            this.dynamicValidateForm.planList = data.planList;
            let skuData = JSON.parse(data.skuData[0]);
            this.addToDay = data.addToDay;
            this.dynamicValidateForm.occOneList = data.occupationList;
            this.dynamicValidateForm.skuRelationAddList = skuData.skuRelationAddList;
            this.dynamicValidateForm.skuList = data.datas.skuList;
            this.dynamicValidateForm.skuSpecList = data.datas.skuSpecList[this.$route.query.planId];

            this.dynamicValidateForm.baseSpecList = [];
            this.dynamicValidateForm.skuBaseTitle = "";
            this.dynamicValidateForm.actionSpeList = [];
            this.dynamicValidateForm.skuSpecList.forEach(item => {
              let map = {};
              if(item.value[0].type === 6 || item.value[0].type === 1){
                map.name = item.name;
                map.specName = item.value[0].specName;
                this.dynamicValidateForm.skuBaseTitle += map.specName + "-";
                this.dynamicValidateForm.baseSpecList.push(map);
              }else if( item.value[0].type === 4 ){
                map.name = item.name;
                let specName = item.value[0].specValue + "-" + item.value[item.value.length-1].specValue + "类";
                map.specName = specName;
                this.dynamicValidateForm.baseSpecList.push(map);
              }else {
                map.name = item.name;
                this.dynamicValidateForm.actionSpeList.push(map);
              }
            });

            if( !this.$$.isValidObj(this.dynamicValidateForm.cards[0].skuSpecNameList) ){
              this.dynamicValidateForm.cards[0].skuSpecNameList = {};
              this.dynamicValidateForm.cards[0].skuSpecValueList = {};
              this.dynamicValidateForm.actionSpeList.forEach(item => {
                this.dynamicValidateForm.cards[0].skuSpecNameList[item.name] = "";
                this.dynamicValidateForm.cards[0].skuSpecValueList[item.name] = "";
              });
            }

            this.dynamicValidateForm.occupationList = this.dynamicValidateForm.skuSpecList[2].value;

            let length = 0, skuSpecList = this.dynamicValidateForm.skuSpecList;
            for (let i in skuSpecList){
              if (length < skuSpecList[i].name.length) length = skuSpecList[i].name.length;
            }
            $('.form-item-label .el-form-item__label').css('width', `${length*18}px`);
            $('.form-item-label .el-form-item__content').css('margin-left', `${length*18}px`);

            this.requestToken = data.orderToken;
            this.dynamicValidateForm.skuSpecList.forEach(item => {
              item.value.forEach(value => {
                if(value.type === 6){
                  this.ageMin = value.optionMinValue;
                  this.ageMax = value.optionMaxValue;
                }
              })
            });
            if (this.dynamicValidateForm.quoteMainNum) {
              this.dynamicValidateForm.cards.forEach(o => {
                this.dynamicValidateForm.occOneList.forEach(item => {
                  item.id === o.occOneId ? o.occTwoList = item.children : [];
                  item.id === o.occOneId ? o.occOneName = item.name : '';
                  return;
                });
              });
              this.dynamicValidateForm.cards.forEach((o, index) => {
                this.dynamicValidateForm.cards[index].occTwoList.forEach(item => {
                  item.id === o.occTwoId ? o.occThreeList = item.children : [];
                  item.id === o.occTwoId ? o.occTwoName = item.name : '';
                  return;
                });
              });
              this.dynamicValidateForm.cards.forEach((o, index) => {
                this.dynamicValidateForm.cards[index].occupationId = 0;
                this.dynamicValidateForm.cards[index].occThreeList.forEach(item => {
                  item.id === this.dynamicValidateForm.cards[index].occThreeId ? this.dynamicValidateForm.cards[index].occId = item.id : '';
                  item.id === this.dynamicValidateForm.cards[index].occThreeId ? this.dynamicValidateForm.cards[index].azcnCode = item.azcnCode : '';
                  item.id === this.dynamicValidateForm.cards[index].occThreeId ? this.dynamicValidateForm.cards[index].occThreeName = item.name : '';
                  item.id === this.dynamicValidateForm.cards[index].occThreeId ? this.dynamicValidateForm.cards[index].realityOccCode = item.realityOccCode : '';
                  return;
                });

                this.dynamicValidateForm.occupationList.forEach(item => {
                  if (this.dynamicValidateForm.cards[index].occupationId === 0) this.dynamicValidateForm.cards[index].occupationId = item.specValue === this.dynamicValidateForm.cards[index].azcnCode ? item.id : 0;
                });

                this.dynamicValidateForm.skuRelationAddList.forEach(item => {
                  if (item.id === this.dynamicValidateForm.cards[index].occupationId) {
                    this.dynamicValidateForm.cards[index].pid = item.id;
                    this.dynamicValidateForm.cards[index].topLevelId = item.pid;
                    return;
                  }
                });

                let dataTitle = this.dynamicValidateForm.skuBaseTitle + o.azcnCode + '类';
                let num = 0;

                this.axios.post('/management/skuproduct/'+this.dynamicValidateForm.cards[index].skuId).then((response) => {
                  let data = response.data;
                  if (data.success) {
                    this.dynamicValidateForm.cards[index].skuInfo = data.datas;

                    this.dynamicValidateForm.skuRelationAddList.forEach(item => {
                      if (item.pid === this.dynamicValidateForm.cards[index].pid && item.topLevelId === this.dynamicValidateForm.cards[index].topLevelId  && item.remarks.indexOf(dataTitle) != -1) {
                        let json = {};
                        json['id'] = item.id;
                        json['specName'] = item.name;
                        json['topLevelId'] = item.pid;
                        if ((this.dynamicValidateForm.cards[index].skuInfo.title + '').toString().indexOf(item.name) !== -1) {
                          dataTitle += "-" + item.name;
                          this.dynamicValidateForm.cards[index].pid = item.id;
                          this.dynamicValidateForm.cards[index].topLevelId = item.pid;
                          o.skuSpecNameList[this.dynamicValidateForm.actionSpeList[num].name] = item.name;
                          num++;
                        }
                        return;
                      }
                    });

                    this.dynamicValidateForm.skuRelationAddList.forEach(item => {
                      if (item.id === this.dynamicValidateForm.cards[index].occupationId) {
                        this.dynamicValidateForm.cards[index].pid = item.id;
                        this.dynamicValidateForm.cards[index].topLevelId = item.pid;
                        return;
                      }
                    });

                    let list = [];
                    this.dynamicValidateForm.skuRelationAddList.forEach(item => {
                      if (item.pid == this.dynamicValidateForm.cards[index].pid && item.topLevelId == this.dynamicValidateForm.cards[index].topLevelId) {
                        let json = {};
                        json['id'] = item.id;
                        json['specName'] = item.name;
                        json['topLevelId'] = item.pid;
                        list.push(json);
                        return;
                      }
                    });
                    this.dynamicValidateForm.cards[index].skuSpecValueList[this.dynamicValidateForm.actionSpeList[0].name] = list;


                    dataTitle = this.dynamicValidateForm.skuBaseTitle + o.azcnCode + '类';
                    this.dynamicValidateForm.actionSpeList.forEach((item,i) => {
                      list = [];
                      if( i !== this.dynamicValidateForm.actionSpeList.length-1 ){
                        dataTitle += "-" + o.skuSpecNameList[item.name];
                        this.dynamicValidateForm.cards[index].skuSpecValueList[item.name].forEach(spec => {
                          if( spec.specName === o.skuSpecNameList[item.name]){
                            this.dynamicValidateForm.cards[index].pid = spec.id;
                            this.dynamicValidateForm.cards[index].topLevelId = spec.topLevelId;
                          }
                        });
                        this.dynamicValidateForm.skuRelationAddList.forEach(item => {
                          if(item.pid === this.dynamicValidateForm.cards[index].pid && item.topLevelId === this.dynamicValidateForm.cards[index].topLevelId  && item.remarks.indexOf(dataTitle) != -1){
                            let json = {};
                            json['id'] = item.id;
                            json['specName'] = item.name;
                            json['topLevelId'] = item.pid;
                            list.push(json);
                            return;
                          }
                        });
                        o.skuSpecValueList[this.dynamicValidateForm.actionSpeList[i+1].name] = list;
                      }
                    });
                  }
                  this.$forceUpdate();
                });
              });
            }
            this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
              loadingInstance.close();
            });
          }
        });
      },
      //-- 订单数据拼接
      orderData() {
        // -- 主数据
        let orderData = {};
        // -- 计划数据
        let ensurePlan = {};
        // -- 被保人数据
        let beInsureData = {};
        let skuIds = '';
        let sellProductId = '';
        orderData.requestToken = this.requestToken;
        orderData.productId = this.$route.query.productId;
        orderData.planId = this.$route.query.planId;
        orderData.companyName = this.dynamicValidateForm.companyName.trim();
        if (this.$$.isValidObj(this.dynamicValidateForm.quoteMainId)) orderData.quoteMainId = this.dynamicValidateForm.quoteMainId;

        this.dynamicValidateForm.cards.forEach((item, index) => {
          // -- ensurePlan内部数据
          let map = {};
          // -- 报价书表格数据
          let ensurePlanName = {};
          skuIds += item.skuInfo.id + ",";
          sellProductId += item.skuInfo.sellInsureId + ",";
          // -- 总保额
          map.coverage = 0;
          for (let skuSpecNameListKey in item.skuSpecNameList) {
            if( (item.skuSpecNameList[skuSpecNameListKey]+"").indexOf("万") !== -1 ){
              map.coverage += parseInt(item.skuSpecNameList[skuSpecNameListKey].replace("万", '') + '000');
            }
          }
          // -- 人数
          map.groupSize = item.groupSize;
          // -- 计划SkuId
          map.skuId = item.skuInfo.id;
          // -- 职业Id
          map.occId = item.occId;
          // -- 职业名称
          map.planOccName = item.occThreeName;
          // -- 职业类别
          map.azcnCode = item.azcnCode;
          // -- 职业代码
          map.realityOccCode = item.realityOccCode;

          let i = 0;

          for (let skuSpecNameListKey in item.skuSpecNameList) {
            let ensurePlanNameMap = {};
            ensurePlanNameMap.name = skuSpecNameListKey;
            ensurePlanNameMap.specName = item.skuSpecNameList[skuSpecNameListKey];
            ensurePlanName[i] = ensurePlanNameMap;
            i = i + 1;
          }
          map.ensurePlanName = JSON.stringify(ensurePlanName);
          ensurePlan[index] = map;
        });
        skuIds = skuIds.slice(0, skuIds.length - 1);
        sellProductId = sellProductId.slice(0, sellProductId.length - 1);
        orderData.skuId = skuIds;
        orderData.sellProductId = sellProductId;
        orderData.ensurePlan = JSON.stringify(ensurePlan);

        // -- 投保数据
        orderData.beInsuredEffectiveDate = this.beInsuredEffectiveDate;  // 起保时间
        orderData.companyName = this.dynamicValidateForm.companyName; // 投保单位
        orderData.idType = this.idType;  // 证件类型
        orderData.socialCreditCode = this.socialCreditCode; // 证件号码
        orderData.companyAddress = this.provinceName + this.cityName + this.areaName + this.specificAddress; // 投保单位地址
        let policyProvinceCode = {"policyProvinceCode" : this.provinceId};
        let policyCityCode = {"policyCityCode" : this.cityId};
        let policyAreaCode = {"policyAreaCode" : this.areaId};
        let extendLists = [];
        extendLists.push(
          JSON.stringify(policyProvinceCode),
          JSON.stringify(policyCityCode),
            JSON.stringify(policyAreaCode)
        );
        orderData.extendLists = JSON.stringify(extendLists);
        orderData.address = this.address; // 联系人地址
        orderData.legalPerson = this.legalPerson; // 联系人姓名
        orderData.mobile = this.mobile; // 联系人手机号码
        orderData.workTelephone = this.mobile;
        orderData.credentialsFile = null;
        orderData.workEmail = this.workEmail; // 联系人邮箱
        this.beInsureTableData.forEach(item => {
          let beInsureMap = {};
          beInsureMap.beInsureName = item.beInsureName; // 被保人姓名
          beInsureMap.beInsureIdCard = item.beInsureIdCard; // 被保人证件号
          beInsureMap.beSkuId = this.dynamicValidateForm.cards[item.bePlan - 1].skuInfo.id; // 被保人skuId
          beInsureMap.beInsureIdType = item.beInsureIdType; // 被保人证件类型
          beInsureMap.beSex = item.beSex; // 被保人性别
          beInsureMap.realityOccCode = item.realityOccCode; // 被保人职业代码
          beInsureMap.beBrithday = item.beBirthday; // 被保人出生日期
          beInsureData[item.beInsureIdCard] = beInsureMap;
        });
        orderData.beInsureData = JSON.stringify(beInsureData);
        // -- 发票数据
        orderData.needInvoices = this.needInvoices;      // true 需要发票  false 不需要发票
        if (this.needInvoices) {
          orderData.receiptType = this.receiptType;      // 2 电子发票 1 纸质发票
          if (this.idType === 6) {
            orderData.tIN = this.socialCreditCode; // 纳税人识别号
          }
          if (this.idType === 11) {
            orderData.tIN = this.orderMailInvoiceInfo.tIN; // 纳税人识别号
          }
          orderData.rName = this.orderMailInvoiceInfo.rName; // 收件人姓名
          orderData.rPhone = this.orderMailInvoiceInfo.rPhone; // 收件人手机号
          if (this.receiptType === 2) {
            orderData.rMail = this.orderMailInvoiceInfo.rMail; // 收件人邮箱
          } else {
            orderData.tRA = this.orderMailInvoiceInfo.tRA; // 税务登记地址
            orderData.tRT = this.orderMailInvoiceInfo.tRT; // 税务登记电话
            orderData.openBank = this.orderMailInvoiceInfo.openBank; // 开户银行
            orderData.bankNum = this.orderMailInvoiceInfo.bankNum; // 	银行账户
            orderData.rCityId = this.orderMailInvoiceInfo.rCityId; // 城市ID
            orderData.rProvinceId = this.orderMailInvoiceInfo.rProvinceId; // 省份ID
            orderData.rAreaId = this.orderMailInvoiceInfo.rAreaId; // 地区ID
            orderData.rAddress = this.orderMailInvoiceInfo.rAddress; // 收件人具体地址
          }
        }
        return orderData;
      },
      // -- 数据校验
      dataIsValid() {
        let isValid = true;
        let reg = /^\d+$/;
        let idTypeSixReg = /^([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}|[1-9]\d{14})$/; // 统一社会信用代码正则校验
        let idTypeElevenRge = /[0-9A-HJ-NPQRTUWXY]{9}/; // 组织机构代码正则校验
        let PHONE_REGEX = /^1(3[0-9]|4[57]|5[0-35-9]|7[0135678]|8[0-9])\d{8}$/;  // 手机号正则校验
        let EMAIL_REGEX = /^([a-zA-Z0-9_\.\-])+[\@,\＠](([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;  // 邮箱正则校验
        let TELEPHONE_REGEX = /^\d{3}-\d{8}|\d{4}-\d{7}$/; // 固定电话校验
        let BANK_NUM_REG = /^[0-9]{1,20}$/; // 银行账户校验
        if (!this.dynamicValidateForm.companyName.trim()) {
          this.$message.error("投保单位不能为空!");
          return isValid = false;
        }
        try {
          this.dynamicValidateForm.cards.forEach((item, index) => {
            if (!this.$$.isValidObj(item.groupSize) || item.groupSize <= 0) {
              throw new Error("保障计划" + this.$$.changeNumToHan(index + 1) + "的投保人数不能为空!");
            }
            if (!reg.test(item.groupSize)) {
              throw new Error("保障计划" + this.$$.changeNumToHan(index + 1) + "的投保人数只能填写数字!");
            }
            if (!this.$$.isValidObj(item.occId)) {
              throw new Error("保障计划" + this.$$.changeNumToHan(index + 1) + "的职业不能为空!");
            }
            if (!this.$$.isValidObj(item.realityOccCode)) {
              throw new Error("保障计划" + this.$$.changeNumToHan(index + 1) + "的职业代码不能为空!");
            }
            if (!this.$$.isValidObj(item.azcnCode)) {
              throw new Error("保障计划" + this.$$.changeNumToHan(index + 1) + "的职业类别不能为空!");
            }
            if (!this.$$.isValidObj(item.skuInfo.id)) {
              throw new Error("保障计划" + this.$$.changeNumToHan(index + 1) + "的保障项目不能为空!");
            }
            this.dynamicValidateForm.cards.forEach((j, i) => {
              if (i !== index && item.skuSpecNameList === j.skuSpecNameList && item.occThreeId === j.occThreeId
              ) {
                throw new Error("存在职业和保障项目相同的计划,请重试!");
              }
            });
          });
        } catch (e) {
          this.$message.error(e.message);
          return isValid = false;
        }

        // -- 投保数据校验
        if (!this.$$.isValidObj(this.beInsuredEffectiveDate)) {
          this.$message.error("请选择起保日期!");
          return isValid = false;
        }
        /*if (this.$$.dateDifference(this.beInsuredEffectiveDate) < 2) {
          this.$message.error("起保日期必须为三天后!");
          return isValid = false;
        }*/
        if (!this.$$.isValidObj(this.areaId)) {
          this.$message.error("请选择投保人所在地区!");
          return isValid = false;
        }
        if (!this.$$.isValidObj(this.specificAddress)) {
          this.$message.error("请填写投保人注册地址!");
          return isValid = false;
        }
        if (this.specificAddress.replace(/[^\u0000-\u00ff]/g, "aa").length > 100) {
          this.$message.error("具体地址最多为50个汉字,请重新输入!");
          return isValid = false;
        }
        if (!this.$$.isValidObj(this.idType)) {
          this.$message.error("请选择证件类型!");
          return isValid = false;
        }
        if (!this.$$.isValidObj(this.socialCreditCode)) {
          this.$message.error("请输入证件号码!");
          return isValid = false;
        }
        if (this.idType === 6 && idTypeSixReg.test(this.socialCreditCode) === false) {
          this.$message.error("统一社会信用代码格式不合法！");
          return isValid = false;
        }
        if (this.idType === 11 && idTypeElevenRge.test(this.socialCreditCode) === false) {
          this.$message.error("组织机构代码证格式不合法！");
          return isValid = false;
        }
        if (!this.$$.isValidObj(this.legalPerson)) {
          this.$message.error("请输入联系人姓名!");
          return isValid = false;
        }
        if (!this.$$.isValidObj(this.mobile)) {
          this.$message.error("请输入联系人手机号!");
          return isValid = false;
        }
        if (PHONE_REGEX.test(this.mobile) === false) {
          this.$message.error("联系人手机号错误,请重新输入!");
          return isValid = false;
        }
        if (!this.$$.isValidObj(this.address)) {
          this.$message.error("请输入联系人地址!");
          return isValid = false;
        }
        if (!this.$$.isValidObj(this.workEmail)) {
          this.$message.error("请输入联系人邮箱!");
          return isValid = false;
        }
        if (EMAIL_REGEX.test(this.workEmail) === false) {
          this.$message.error("联系人邮箱错误,请重新输入!");
          return isValid = false;
        }
        // -- 被保人数据校验
        if (this.$$.isEmptyObject(this.beInsureTableData)) {
          this.$message.error("被保人为空,请上传被保人!");
          return isValid = false;
        }
        // -- 检查被保人列表是否有错误信息
        try {
          this.beInsureTableData.forEach((item, index) => {
            if (this.$$.isValidObj(item.ageErrorMsg) || this.$$.isValidObj(item.codeErrorMsg) || this.$$.isValidObj(item.planErrorMsg)){
              throw new Error("序号:" + (index + 1) + "存在错误信息,请删除!");
            }
          });
        } catch (e) {
          this.$message.error(e.message);
          return isValid = false;
        }
        if (this.needInvoices) {
          if (this.idType !== 6 && !this.$$.isValidObj(this.orderMailInvoiceInfo.tIN)) {
            this.$message.error("请输入发票纳税人识别号!");
            return isValid = false;
          }
          if (this.idType !== 6 && !idTypeSixReg.test(this.orderMailInvoiceInfo.tIN)) {
            this.$message.error("纳税人识别号错误,请重新输入!");
            return isValid = false;
          }
          if (!this.$$.isValidObj(this.orderMailInvoiceInfo.rName)) {
            this.$message.error("请输入收件人姓名!");
            return isValid = false;
          }
          if (!this.$$.isValidObj(this.orderMailInvoiceInfo.rPhone)) {
            this.$message.error("请输入收件人手机号!");
            return isValid = false;
          }
          if (PHONE_REGEX.test(this.orderMailInvoiceInfo.rPhone) === false) {
            this.$message.error("收件人手机号错误,请重新输入!");
            return isValid = false;
          }
          // 2 电子发票 1 纸质发票
          if (this.receiptType === 2) {
            if (!this.$$.isValidObj(this.orderMailInvoiceInfo.rMail)) {
              this.$message.error("请输入收件人邮箱!");
              return isValid = false;
            }
            if (EMAIL_REGEX.test(this.orderMailInvoiceInfo.rMail) === false) {
              this.$message.error("收件人邮箱错误,请重新输入!");
              return isValid = false;
            }
          } else {
            if (!this.$$.isValidObj(this.orderMailInvoiceInfo.tRA)) {
              this.$message.error("请输入税务登记地址!");
              return isValid = false;
            }
            if (!this.$$.isValidObj(this.orderMailInvoiceInfo.tRA)) {
              this.$message.error("请输入税务登记地址!");
              return isValid = false;
            }
            if (!this.$$.isValidObj(this.orderMailInvoiceInfo.tRT)) {
              this.$message.error("请输入税务登记电话!");
              return isValid = false;
            }
            if (TELEPHONE_REGEX.test(this.orderMailInvoiceInfo.tRT) === false) {
              this.$message.error("税务登记电话错误,请重新输入!");
              return isValid = false;
            }
            if (!this.$$.isValidObj(this.orderMailInvoiceInfo.tRT)) {
              this.$message.error("请输入税务登记电话!");
              return isValid = false;
            }
            if (!this.$$.isValidObj(this.orderMailInvoiceInfo.openBank)) {
              this.$message.error("请输入开户银行!");
              return isValid = false;
            }
            if (!this.$$.isValidObj(this.orderMailInvoiceInfo.bankNum)) {
              this.$message.error("请输入银行账户!");
              return isValid = false;
            }
            if (!this.$$.bankCardVerification(this.orderMailInvoiceInfo.bankNum)){
              this.$message.error("银行账户错误,请重新输入!");
              return isValid = false;
            }
            if (!this.$$.isValidObj(this.orderMailInvoiceInfo.rAreaId)) {
              this.$message.error("请选择收件人地址!");
              return isValid = false;
            }
            if (!this.$$.isValidObj(this.orderMailInvoiceInfo.rAddress)) {
              this.$message.error("请输入收件人具体地址!");
              return isValid = false;
            }
          }
        }
        this.beInsureErrorMsg = [];
        this.dynamicValidateForm.cards.forEach((item, index) => {
          let beInsureGroupSize = 0;
          this.beInsureTableData.forEach(user => {
            if( user.bePlan === index + 1 ){
              beInsureGroupSize++;
            }
          });
          if ( beInsureGroupSize.toString() !== item.groupSize.toString() ) {
            this.beInsureErrorMsg.push("投保计划" + this.$$.changeNumToHan(index + 1) + "人数" + item.groupSize + "人,已上传" + beInsureGroupSize + "人,不符!");
          }
        });
        if( !this.$$.isEmptyObject(this.beInsureErrorMsg) ){
          this.beInsureErrorMsgDialogVisible = true;
          isValid = false;
        }
        // -- 我已阅读
        if( !this.checked ){
          this.$message.error("请先勾选相关协议条款和声明！");
          isValid = false;
        }
        return isValid;
      },
      // -- 省份改变事件
      rProvinceChange() {
        this.$forceUpdate();
        this.chinaArea.forEach(item => {
          item.value === this.orderMailInvoiceInfo.rProvinceId ? this.orderMailInvoiceInfo.rCityList = item.children : [];
        });
        this.orderMailInvoiceInfo.rCityId = '';
        this.orderMailInvoiceInfo.rAreaId = '';
      },
      // -- 城市改变事件
      rCityChange() {
        this.$forceUpdate();
        this.orderMailInvoiceInfo.rCityList.forEach(item => {
          item.value === this.orderMailInvoiceInfo.rCityId ? this.orderMailInvoiceInfo.rAreaList = item.children : [];
        });
        this.orderMailInvoiceInfo.rAreaId = '';
      },
      // -- 省份改变事件(联系人)
      provinceChange() {
        this.$forceUpdate();
        this.chinaArea.forEach(item => {
          item.value === this.provinceId ? this.cityList = item.children : [];
          item.value === this.provinceId ? this.provinceName = item.label : '';
        });
        this.cityId = '';
        this.areaId = '';
        this.cityName = '';
        this.areaName = '';
      },
      // -- 城市改变事件(联系人)
      cityChange() {
        this.$forceUpdate();
        this.cityList.forEach(item => {
          item.value === this.cityId ? this.areaList = item.children : [];
          item.value === this.cityId ? this.cityName = item.label : '';
        });
        this.areaId = '';
        this.areaName = '';
      },
      // -- 地区改变时间(联系人)
      areaChange() {
        this.$forceUpdate();
        this.areaList.forEach(item => {
          item.value === this.areaId ? this.areaName = item.label : '';
        });
      },
      // -- 新增被保人提交
      submitAddDialogVisible() {
        if (!this.$$.isValidObj(this.addBeInsureData.addBeInsureName)) {
          this.$message.error("被保人姓名不能为空!");
          return;
        }
        if (!this.$$.isValidObj(this.addBeInsureData.bePlan)) {
          this.$message.error("被保人保障计划不能为空!");
          return;
        }
        if (!this.$$.isValidObj(this.addBeInsureData.addBeBirthday)) {
          this.$message.error("请选择被保人出生日期!");
          return;
        }
        if (!this.$$.isValidObj(this.addBeInsureData.addBeSex)) {
          this.$message.error("请选择被保人性别!");
          return;
        }
        if (!this.$$.isValidObj(this.addBeInsureData.addBeInsureIdCard)) {
          this.$message.error("被保人证件号码不能为空!");
          return;
        }
        if (!this.$$.isValidObj(this.addBeInsureData.addBeInsureIdType)) {
          this.$message.error("请选择被保人证件类型!");
          return;
        }
        if (this.addBeInsureData.addBeInsureIdType === 1 && this.$$.constant.beInsureIdTypeOneReg.test(this.addBeInsureData.addBeInsureIdCard) === false) {
          this.$message.error("身份证格式不正确!");
          return;
        }
        if (this.$$.getAge(this.addBeInsureData.addBeBirthday.replace(/-/g, '')) < this.ageMin || this.$$.getAge(this.addBeInsureData.addBeBirthday.replace(/-/g, '')) > this.ageMax) {
          this.$message.error("投保年龄必须大于"+this.ageMin+"岁小于"+this.ageMax+"岁!");
          return;
        }
        try {
          this.beInsureTableData.forEach(data => {
            if (this.addBeInsureData.addBeInsureIdCard === data.beInsureIdCard) {
              throw new Error("被保人证件号码:" + data.beInsureIdCard + "已存在!");
            }
          });
        } catch (e) {
          this.$message.error(e.message);
          return;
        }
        let map = {};
        map.beInsureName = this.addBeInsureData.addBeInsureName;
        map.realityOccCode = this.addBeInsureData.addRealityOccCode;
        map.beBirthday = this.addBeInsureData.addBeBirthday.toString().replace(/-/g, '');
        map.beSex = this.addBeInsureData.addBeSex;
        map.bePlan = this.addBeInsureData.bePlan;
        map.beInsureIdCard = this.addBeInsureData.addBeInsureIdCard;
        map.beInsureIdType = this.addBeInsureData.addBeInsureIdType;
        this.beInsureTableData.push(map);
        this.addBeInsureData.addBeInsureName = '';
        this.addBeInsureData.addRealityOccCode = '';
        this.addBeInsureData.addBeBirthday = '';
        this.addBeInsureData.addBeSex = '';
        this.addBeInsureData.addBeInsureIdCard = '';
        this.addBeInsureData.addBeInsureIdType = '';
        this.addBeInsureData.bePlan = '';
        this.addDialogVisible = false;
      },
      // -- 隐藏被保人新增框
      cancelAddDialogVisible() {
        this.addBeInsureData.addBeInsureName = '';
        this.addBeInsureData.addRealityOccCode = '';
        this.addBeInsureData.addBeBirthday = '';
        this.addBeInsureData.addBeSex = '';
        this.addBeInsureData.addBeInsureIdCard = '';
        this.addBeInsureData.addBeInsureIdType = '';
        this.addBeInsureData.bePlan = '';
        this.addDialogVisible = false;
      },
      // -- 删除被保人
      deleteBeInsureTableData(index, rows) {
        rows.splice(index, 1);
      },
      // -- 选中被保人事件
      handleSelectionChange(val) {
        this.beInsureSelection = val;
      },
      // -- 批量删除被保人
      deleteBeInsureTableDataBatch() {
        this.beInsureSelection.forEach(item => {
          this.beInsureTableData.forEach((beInsure,index) => {
            if( item === beInsure ){
              this.beInsureTableData.splice(index,1);
            }
          });
        });
      },
      // -- 上传被保人列表Excel文件
      uploadFileExcel(file) {

        if (file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' &&
            file.type !== 'application/vnd.ms-excel'
        ) {
          this.$message.error('只能上传xlsx文件');
          return false;
        }
        let productId = this.$route.query.productId+"";
        const formData = new window.FormData();
        formData.append('file', file);
        formData.append('formType', '40');
        formData.append('formId', productId);
        let loadingInstance = this.Loading.service({fullscreen: true});

        this.loading = true;
        this.axios.post('/upload/attachment/upload',
          formData,
          {headers: {"Content-Type": "multipart/form-data"}},
        ).then((response) => {
          this.loading = false;
          let data = response.data;

          if (data.success) {
            data.datas.ExcelData.forEach(item => {
              let map = {}, realityOccCodes = '';
              map.beInsureName = item.name;
              map.realityOccCode = item.realityOccCode;
              map.beBirthday = item.birthday;
              map.beSex = item.sex;
              map.beInsureIdCard = item.idCard;
              map.bePlan = item.bePlan;
              map.beInsureIdType = item.idType;

              this.beInsureTableData.forEach(data => {
                if (item.idCard === data.beInsureIdCard) {
                  map.idCardErrorMsg = "被保人证件号码存在重复";
                }
              });
              if (this.$$.getAge(item.birthday) < this.ageMin || this.$$.getAge(item.birthday) > this.ageMax) {
                map.ageErrorMsg = "投保年龄不满足投保条件";
              }

              this.dynamicValidateForm.cards.forEach(code => {
                realityOccCodes += code.realityOccCode + ',';
              });

              if (realityOccCodes.indexOf(item.realityOccCode) === -1) {
                map.codeErrorMsg = "职业代码不存在或错误";
              }

              if (item.bePlan > this.dynamicValidateForm.cards.length) {
                map.planErrorMsg = "计划不存在";
              }
              this.beInsureTableData.push(map);
            });
            this.$message.success("导入成功");
          } else {
            this.$message.error(data.msg);
          }
        });
        this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
          loadingInstance.close();
        });
        return false;
      },
      planLocation(){
        this.beInsureErrorMsgDialogVisible = false;
        document.getElementById("planLocation").scrollIntoView();
      },
      beInsureLocation(){
        this.beInsureErrorMsgDialogVisible = false;
        document.getElementById("beInsureLocation").scrollIntoView();
      },
      // -- 订单提交
      submitOrder() {
        if (!this.dataIsValid()) {
          return;
        }
        this.submitOrderData = this.orderData();
        let loadingInstance = this.Loading.service({fullscreen: true});
        this.axios.post('/management/mobileBusinessInsurance/rule_fillInsuranceInfo_verify', this.submitOrderData).then((response) => {
          if (response.data.success) {
            //-- 会话存储 - 参数
            this.src = "";
            sessionStorage.setItem('allData', JSON.stringify(this.$data));
            this.$router.push({name: 'insureConfirm', query:{productId: this.$route.query.productId, planId: this.$route.query.planId}});
          } else {
            this.$message.error(response.data.msg);
          }
          this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
            loadingInstance.close();
          });
        });
      },
      //-- 身份证转换 - 性别、出生日期
      addBeInsureIdCardChange() {
        let idCard = this.addBeInsureData.addBeInsureIdCard;

        if (idCard.length >= 18 && this.$$.constant.beInsureIdTypeOneReg.test(idCard) === true){
          //-- 识别 - 性别
          let cardState = parseInt(idCard.substr(16,1))%2==1;
          this.addBeInsureData.addBeSex = cardState ? "M" : "F";

          //-- 识别 - 性别
          let birthday = idCard.slice(6,14);
          birthday = birthday.replace(/(.{4})(.{2})/,"$1-$2-");   //通过正则表达式来指定输出格式为:1990-01-01
          this.addBeInsureData.addBeBirthday = birthday;
        }
      },
      groupSizeChange (e) {
        this.$forceUpdate()
      },
    },
    mounted() {
      this.bankTypeLists();
      let dynamicValidateForm = sessionStorage.getItem('dynamicValidateForm');
      let allData = sessionStorage.getItem('allData');

      if (this.$$.isValidObj(allData) && allData != 'undefined') {
        allData = JSON.parse(allData);
        Object.assign(this.$data, allData);
        this.pickerOptions.disabledDate = this.disabledDate;
      }else if (this.$$.isValidObj(dynamicValidateForm)){
        dynamicValidateForm = JSON.parse(dynamicValidateForm);

        if (this.$$.isValidObj(dynamicValidateForm.quoteMainNum)) {
          this.dynamicValidateForm.companyName = dynamicValidateForm.companyName;
          this.dynamicValidateForm.quoteMainNum = dynamicValidateForm.quoteMainNum;
          this.dynamicValidateForm.quoteMainId = dynamicValidateForm.quoteMainId;
          this.dynamicValidateForm.projectName = dynamicValidateForm.projectName;

          dynamicValidateForm.cards.forEach((item, index) => {
            if (this.dynamicValidateForm.cards.length < index + 1) {
              this.dynamicValidateForm.cards[index] = JSON.parse(JSON.stringify(this.dynamicValidateForm.cards[0]));
            }
            this.dynamicValidateForm.cards[index].groupSize = item.groupSize;
            this.dynamicValidateForm.cards[index].occOneId = item.occOneId;
            this.dynamicValidateForm.cards[index].occTwoId = item.occTwoId;
            this.dynamicValidateForm.cards[index].occThreeId = item.occThreeId;
            this.dynamicValidateForm.cards[index].skuId = item.skuId;
          });
        }else {
          this.dynamicValidateForm = dynamicValidateForm;
        }
        this.getInsuranceClause();
        this.getSkuInfo();
      }else {
        this.$confirm('当前订单参数错误，请重新进入~', '温馨提示：', {
          showClose: false,
          closeOnClickModal: false,
          center: true,
          showCancelButton: false,
          confirmButtonText: '确认',
        }).then(() => {
          this.$router.push({name: 'quotationManagement'});
        });
      }
    },
    updated() {

      let length = 0, skuSpecList = this.dynamicValidateForm.skuSpecList;
      for (let i in skuSpecList){
        if (length < skuSpecList[i].name.length) length = skuSpecList[i].name.length;
      }
      $('.form-item-label .el-form-item__label').css('width', `${length*18}px`);
      $('.form-item-label .el-form-item__content').css('margin-left', `${length*18}px`);
    }
  }

</script>

<style scoped>

  .box-card {
    width: auto;
    height: auto;
    padding: 20px;
    margin-bottom: 2.5rem;
  }

  .box-card-div{
    position: relative;
  }

  .box-card-div-title {
    height: 12px;
    background: #FFBF00;
    font-size: 24px;
    font-weight: bold;
    color: #333333;
    margin-bottom: 10px;
    display: inline-block;
    position: relative;
  }

  .box-card-div>span{
    position: absolute;
    right: 0;
    top: -20px;
  }

  .box-card-div-title.userInfo{
    width: 96px;
  }

  .supportPlan{
    width: 120px;
  }

  .box-card-div-title>.header{
    text-align: center;
    position: absolute;
    left: 0;
    top: -20px;
  }

  .box-card-div>span {
    display: inline-block;
    float: right;
  }


  .form-item-label {
    font-size: 1rem;
    font-weight: 500;
    color: #333333;
    margin: 0 auto 10px;
    position: relative;
  }

  .form-item-label-add {
    font-size: 16px;
    font-weight: 500;
    color: #333333;
    text-align: left;
    padding-top: 5px;
    margin-bottom: 4px !important;
  }


  .form-item-label-big {
    font-weight: bold;
    color: #333333;
    margin-top: -10px;
  }

  .form-item-label-big /deep/ .el-form-item__content{
    padding-left: 10px;
  }

  .header-span {
    font-size: 1rem;
    font-weight: 400;
    color: #333333;
  }

  .form-item-input {
    height: 40px;
    width: 144px;
    max-width: 640px;
    background: #F7F7F7;
    margin: 0 5px 5px 10px;
    text-align: center;
    display: inline-block;
  }

  .form-item-input-add {
    background: #F7F7F7 !important;
  }

  /deep/ .header-content {
    text-align: center;
  }

  .p-title {
    font-size: 2.5rem;
    color: #333333;
    font-weight: bold;
    font-style: italic;
  }

  .row-bg {
    padding: 60px 0 40px;
  }

  .submitOrder{
    width: 100%;
    margin: 0 auto;
    text-align: center;
  }

  .header-button-order-add {
    width: 20rem;
    background: #FF7052 !important;
    border-radius: 12px;
    font-size: 16px;
    font-weight: 500;
    color: #FFFFFF !important;
    margin-top: 25px;
  }

  .header-button-order-add:hover {
    color: #FFFFFF !important;
    background: #FF7052 !important;
  }

  .my-button {
    margin-right: 30px;
    background-color: #F7F7F7;
  }

  .header-row-col-button-success {
    width: auto;
    height: 40px;
    background-color: #528BFF !important;
    font-size: 16px;
    font-weight: 500;
    color: #FFFFFF !important;
    margin: 0 30px 5px 0;
    border-radius: 12px !important;
    border: 0 !important;
  }

  .header-row-col-button-success a{
    color: #ffffff;
    border: none;
  }

  .header-row-col-button-success a:link{
    text-decoration:none;
  }

  .header-row-col-button-failure {
    width: auto;
    height: 40px;
    background-color: #FF7052 !important;
    font-size: 16px;
    font-weight: 500;
    color: #FFFFFF !important;
    margin-right: 30px;
    border-radius: 12px !important;
    border: 0 !important;
  }

  .header-row-col-button-success:hover {
    color: #FFFFFF !important;
    background: #528BFF !important;
  }

  .header-row-col-button-failure:hover {
    color: #FFFFFF !important;
    background: #FF7052 !important;
  }

  .my-el-table {
    width: 900px;
  }

  .my-el-date-picker {
    width: calc(100% - 25px) !important;
    min-width: 144px;
    margin-left: 10px;
  }

  .my-el-date-picker-add {
    width: 264px !important;
  }

  .header-row-col-button-success-add {
    width: 144px;
    height: 40px;
    background-color: #FF7052 !important;
    font-size: 16px;
    font-weight: 500;
    color: #FFFFFF !important;
    border-radius: 12px !important;
    border: 0 !important;
    margin-left: 20px;
  }

  .header-row-col-button-failure-add {
    width: 144px;
    height: 40px;
    background-color: #D9D9D9 !important;
    font-size: 16px;
    font-weight: 500;
    color: #FFFFFF !important;
    border-radius: 12px !important;
    border: 0 !important;
    margin-right: 20px;
  }

  .header-row-col-button-success-add:hover {
    color: #FFFFFF !important;
    background: #FF7052 !important;
  }

  .header-row-col-button-failure-add:hover {
    color: #FFFFFF !important;
    background: #D9D9D9 !important;
  }

  .my-step {
    padding-top: 63px;
  }

  /* 已完成title文字颜色 */
  .my-step /deep/ .is-finish {
    font-size: 1rem;
    font-weight: 500;
    font-style: italic;
    color: #FF7052;
  }

  /* 进行中title文字颜色 */
  .my-step /deep/ .is-process {
    font-size: 1rem;
    font-weight: 500;
    font-style: italic;
    color: #FF7052;
  }

  /* 等待中title文字颜色*/
  .my-step /deep/ .is-wait {
    font-size: 1rem;
    font-weight: 500;
    font-style: italic;
    color: #666666;
  }

  /* 圆圈数字颜色*/
  .my-step /deep/ .el-step__icon-inner {
    padding-right: 6px;
    font-size: 1.5rem;
    font-style: italic !important;
    font-weight: 800;
    color: #FFFFFF;
  }

  /* 圆圈数字颜色*/
  .my-step /deep/ .el-step__icon-inner:before {
    content: '0';
  }

  /*is-text 圆圈颜色*/
  .my-step /deep/ .is-finish .is-text {
    background: #EB6F67 !important;
    border-color: #EB6F67 !important;
    width: 56px;
    height: 56px;
    margin-top: -45px;
  }

  /*is-text 圆圈颜色*/
  .my-step /deep/ .is-process .is-text {
    background: #EB6F67 !important;
    border-color: #EB6F67 !important;
    width: 56px;
    height: 56px;
    margin-top: -45px;
  }

  /*is-text 圆圈颜色*/
  .my-step /deep/ .is-wait .is-text {
    background: #CCCCCC !important;
    border-color: #CCCCCC !important;
    width: 56px;
    height: 56px;
    margin-top: -45px;
  }

  /*is-finish 圆圈颜色*/
  .my-step /deep/ .el-steps.el-steps--horizontal {
    color: #EB6F67 !important;
    border-color: #EB6F67 !important;

  }

  .my-step /deep/ .el-step.is-horizontal.is-center {
    color: #EB6F67 !important;
    border-color: #EB6F67 !important;
  }

  .my-step /deep/ .el-step__head.is-finish {
    color: #EB6F67 !important;
    border-color: #EB6F67 !important;
  }

  /*is-process 圆圈颜色*/
  .my-step /deep/ .el-steps.el-steps--horizontal {
    color: #FF7052;
    border-color: #FF7052;
  }

  .my-step /deep/ .el-step__head.is-process {
    color: #FF7052;
    border-color: #FF7052;
  }

  .my-step /deep/ .el-step.is-horizontal.is-center {
    color: #FF7052;
    border-color: #FF7052;
  }

  /* 输入框去圆角 */
  .my-input /deep/ .el-input__inner {
    border: 0 !important;
    font-size: 1rem;
    font-weight: 400;
    color: #333333 !important;
    background-color: #F7F7F7 !important;
    text-align: center !important;
  }

  .my-input-left{
    width: calc(100% - 35px);
    min-width: 144px;
  }

  .my-el-date-picker{
    max-width: 640px;
  }

  /* 输入框文字左对齐 */
  .my-input-left /deep/ .el-input__inner {
    border: 0 !important;
    font-size: 16px;
    font-weight: 400;
    color: #333333 !important;
    background-color: #F7F7F7 !important;
    text-align: left !important;
  }

  /* 必填框去掉*号 */
  .form-item-label /deep/ .el-form-item__label:before {
    color: #FFFFFF !important;
    margin-right: 0!important;
    content: '' !important;
  }

  .form-item-label /deep/ .el-form-item__label {
    font-size: 1rem !important;
    margin: 0 auto;
  }

  /* 必填框去掉*号 */
  .form-item-label-big /deep/ .el-form-item__label:before {
    color: #FFFFFF !important;
  }

  .form-item-label-big /deep/ .el-form-item__label {
    font-size: 1.25rem !important;
    font-weight: bold;
  }

  /* 必填框去掉*号 */
  .form-item-label-add /deep/ .el-form-item__label:before {
    color: #FFFFFF !important;
  }

  .form-item-label-add /deep/ .el-form-item__label {
    font-size: 16px !important;
    width: 100px !important;
    text-align: right !important;
    padding-right: 25px !important;
  }

  .underwriterDetailed /deep/ .el-form-item__content{
    padding-left: 10px;
  }

  .el-dialog__wrapper /deep/ .el-form-item__content{
    margin-left: 100px!important;
  }

  /* 取出radio圆角 */
  .my-button .el-radio-button:first-child /deep/ .el-radio-button__inner {

  }

  /* 选择项的颜色 */
  .is-active /deep/ .el-radio-button__inner {
    box-shadow: none !important;
    -webkit-box-shadow: none !important;
    background-color: #FFEEEB !important;
    color: #FF7052 !important;
    border: 1px solid #FF7052 !important;
  }

  .my-button /deep/ .el-radio-button__inner {
    box-shadow: 0 0 0 0 !important;
    -webkit-box-shadow: 0 0 0 0 !important;
    border: 0;
    border-radius: 0 !important;
    background-color: #F7F7F7;
    color: #333333;
  }

  .el-radio-button:first-child /deep/ .el-radio-button__inner {
    border-left: 0;
  }

  .is-active /deep/ .el-radio-button__inner:hover {
    color: #FF7052 !important;
  }

  .my-button /deep/ .el-radio-button__inner:hover {
    color: #333333;
  }

  .el-input--prefix /deep/ .el-input__inner {
    text-align: center!important;
    background-color: #F7F7F7;
    border: 0;
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    padding: 0 30px 0 10px;
  }

  /deep/ .el-dialog--center {
    box-shadow: 0 12px 28px 0 rgba(204, 204, 204, 0.25) !important;
    border-radius: 16px !important;
  }

  .el-dialog--center /deep/ .el-dialog__body {
    text-align: center !important;
    padding: 15px 25px 10px;
  }

  .dialog-footer{
    margin: 20px auto;
    text-align: center;
  }

  /* 新增被保人输入框去圆角 */
  .my-input-add /deep/ .el-input__inner {
    border: 0 !important;
    font-size: 16px;
    font-weight: 400;
    color: #333333 !important;
    background-color: #F7F7F7 !important;
    text-align: center !important;
    padding: 0 30px 0 10px;
  }

  /deep/ .el-dialog__title {
    font-size: 24px;
    font-weight: bold;
    color: #333333;
  }

  /deep/ .el-dialog__header {
    padding: 40px 20px 0;
  }

  .el-dialog__headerbtn /deep/ .el-dialog__close{
    font-weight: bold;
    font-size: 2rem;
  }

  .box-card /deep/ .is-leaf {
    background: #f0f0f0;
    text-align: center;
    line-height: 0;
  }

  .specialTip{
    width: 1rem;
    height: 1rem;
    padding: 0;
    border-radius: 50%;
    border: 1px solid #F2613F;
    display: inline-block;
    text-align: center;
    font-size: .75rem;
    line-height: 10px;
    position: absolute;
    top: calc((40px - 1rem)/2);
    left: 165px
  }
  .specialTip:before {
    width: 1rem;
    height: 1rem;
    content: '?';
    font-weight: bold;
    color: #F2613F;
  }
  .el-checkbox-span-a {
    display: inline-block;
  }

  /deep/ .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  /deep/ .el-dropdown {
    font-size: inherit !important;
  }

  .true{
    color: #FFFFFF!important;
    background-color: #f2613f!important;
    height: 40px;
    width: 144px;
    max-width: 640px;
    margin: 0 5px 5px 10px;
    text-align: center;
    display: inline-block;
  }
  .false{
    height: 40px;
    width: 144px;
    max-width: 640px;
    background: #F7F7F7;
    margin: 0 5px 5px 10px;
    text-align: center;
    display: inline-block;
  }

  /* 输入框文字左对齐 */
  .true /deep/ .el-input__inner {
    border: 0 !important;
    font-size: 16px;
    font-weight: 400;
    color: #FFFFFF!important;
    background-color: #f2613f!important;
    text-align: left !important;
  }

  /* 输入框文字左对齐 */
  .false /deep/ .el-input__inner {
    border: 0 !important;
    font-size: 16px;
    font-weight: 400;
    color: #333333 !important;
    background-color: #F7F7F7 !important;
    text-align: left !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/chinaLifeAccidentInsurance/insureDetails.vue